import { render, staticRenderFns } from "./TemplateType.vue?vue&type=template&id=d5822d40&scoped=true&"
import script from "./TemplateType.vue?vue&type=script&lang=js&"
export * from "./TemplateType.vue?vue&type=script&lang=js&"
import style0 from "./TemplateType.vue?vue&type=style&index=0&id=d5822d40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5822d40",
  null
  
)

export default component.exports